export default __webpack_public_path__ + "static/media/pro_aim_hotel.f41f31ec.png";